import { __require as o } from "./main66.js";
var r, t;
function u() {
  if (t) return r;
  t = 1;
  var s = o(), i = Object.prototype, n = i.hasOwnProperty;
  function h(a) {
    var e = this.__data__;
    return s ? e[a] !== void 0 : n.call(e, a);
  }
  return r = h, r;
}
export {
  u as __require
};
